import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE, Reveal, Eyebrow } from "./Shared";

const FAQS = [
  ["What exactly is BLUEPRINT™?", "A business-and-identity experience by Dasha Love for entrepreneurs, creators, coaches, authors, and visionaries. It brings your beliefs, identity, why, message, market, offer, and action into one direction — so the business you build matches the person you’re becoming."],
  ["What do I get for $111?", "The complete BLUEPRINT course, all lessons and masterclasses, access to Dasha Love’s Skool community, and instant digital access — plus a BONUS copy of the BECOMING HER Blueprint™ book by Dasha Love. One payment — everything included."],
  ["Is anything physical shipped to me?", "BLUEPRINT itself is 100% digital — the course, books, and community unlock instantly after checkout. Your bonus BECOMING HER Blueprint™ book details arrive with your order confirmation."],
  ["When and how do I get access?", "Immediately after checkout you’ll receive your access details by email, including your invite to the private Skool community."],
  ["Do I need an existing business?", "No. Whether you’re holding an idea, mid-pivot, or running an established brand, BLUEPRINT meets you where you are and designs what’s next from the identity up."],
  ["Do you guarantee income or business results?", "No. BLUEPRINT is personal-development and business education. Nothing here is financial advice, and no specific income or business outcome is promised."],
  ["Is this manifestation, healing, or therapy?", "No. The identity, belief, meditation, and quantum-themed work inside BLUEPRINT is framed as reflection, creativity, and experimentation practice — not therapy, medical advice, or a scientific claim."],
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="relative py-20 sm:py-32 bg-coal/40 border-y border-cream/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow>Before you decide</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl">
              Questions,{" "}
              <span className="font-serif italic normal-case font-medium text-lime">answered.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-sm leading-relaxed text-fog max-w-xs">
              Everything you need to know before you build your blueprint.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8 border-t border-cream/10">
          {FAQS.map(([q, a], i) => (
            <div key={q} data-testid={`faq-accordion-item-${i + 1}`} className="border-b border-cream/10">
              <button
                data-testid={`faq-toggle-${i + 1}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 py-5 sm:py-6 text-left group"
              >
                <span className="text-base sm:text-lg text-cream/90 group-hover:text-lime transition-colors duration-300 font-medium">
                  {q}
                </span>
                <Plus
                  size={18}
                  className={`shrink-0 text-lime transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 max-w-2xl text-sm sm:text-base leading-relaxed text-fog">{a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
